import namespace from './namespace';

export default  {
	[namespace.getters.GET_NOTIFICATIONS]: (state) => {
		return state[namespace.state.NOTIFICATIONS];
	},
	[namespace.getters.CONTEXT_PATH]: (state) => {
		return state[namespace.state.CONFIG].contextPath;
	},
	[namespace.getters.IMAGE_PATH]: (state) => {
		return state[namespace.state.CONFIG].contextPath + "/Content/Images/";
	},
	[namespace.getters.GET_COOKIE_STORE]: (state) => {
		return state[namespace.state.COOKIE_STORE];
	}
};


// WEBPACK FOOTER //
// ./src/store/modules/app/getters.js